import {
  ASSOCIATED_CLAIMLINE_LOADING,
  ASSOCIATED_CLAIMLINE_SUCCESS,
  ASSOCIATED_CLAIMLINE_FAILED
} from '../actions/associatedClaimLinesActions'

const AssociatedClaimLines = (state = {}, action) => {
  switch (action.type) {
    case ASSOCIATED_CLAIMLINE_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        associatedClaimLines: null,
        error: null
      })
    case ASSOCIATED_CLAIMLINE_SUCCESS:
      return Object.assign({}, state, {
        associatedClaimLines: action.response,
        error: null,
        isLoading: false
      })
    case ASSOCIATED_CLAIMLINE_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        associatedClaimLines: null,
        isLoading: false
      })
    default:
      return state
  }
}
export default AssociatedClaimLines



// WEBPACK FOOTER //
// ./src/redux/reducers/associatedClaimLinesReducer.js